import AwardPointsComponent from "./AwardPointsComponent";
import CatalogsSelectView from "./CatalogsSelectView";
import CheckInGeoTableComponent from "./CheckInGeoTableComponent";
import ContentListViewComponent from "./ContentListViewComponent";
import DayPartingViewComponent from "./DayPartingViewComponent";
import EmptyDataRenderer from "./EmptyDataRenderer";
import FraudRuleViewComponent from "./FraudRuleViewComponent";
import MatchKeywordsViewComponent from "./MatchKeywordsViewComponent";
import PackageDateViewComponent from "./PackageDateView";
import ReadArticleComponent from "./ReadArticleComponent";

import ReceiptDateComponent from "./ReceiptDateComponent";
import SegmentViewComponent from "./SegmentViewComponent";
import SelectedCodeGroups from "./SelectedCodeGroups";
import SweepstakesOutcomeComponent from "./SweepstakesOutcomeComponent";
import WatchVideoComponent from "./WatchVideoComponent";
import WinningScheduleComponent from "./WinningScheduleComponent";

// Define your components outside of ViewComponentsRenderer
const DayPartingView = (props) => <DayPartingViewComponent {...props} />;
const MatchBrandsKeywordsView = (props) => (
  <MatchKeywordsViewComponent {...props} filterBy="BRAND" />
);
const MatchOutletsKeywordsView = (props) => (
  <MatchKeywordsViewComponent {...props} filterBy="OUTLET" />
);
const MatchProductsKeywordsView = (props) => (
  <MatchKeywordsViewComponent {...props} filterBy="PRODUCT" />
);
const UserInSegmentView = (props) => {
  const segmentIds = props.data?.segment_ids || props.data?.segment_id || [];
  return <SegmentViewComponent {...props} segmentIds={segmentIds} />;
};
const ReceiptInDateRangeView = (props) => (
  <ReceiptDateComponent
    currentProgramTimezone={props.currentProgramTimezone}
    {...props}
    data={props.data || []}
  />
);

const EmptyDataComponent = (props) => <EmptyDataRenderer {...props} />;

const CodeGroupIdsView = (props) => (
  <SelectedCodeGroups {...props} data={props.data} />
);
const PromotionalProductContentView = (props) => (
  <ContentListViewComponent
    {...props}
    data={props.data}
    contentKey="product_ids"
    contentDefinitionSlug="promotional-product-content"
    label="Selected Products"
  />
);

const TakeASurveyContentView = (props) => (
  <ContentListViewComponent
    {...props}
    data={props.data}
    contentKey="ids"
    contentDefinitionSlug="survey-quiz-content"
    label="Selected Survey/Quiz"
  />
);

const PackageDateView = (props) => <PackageDateViewComponent {...props} />;
const CatalogsSelectViewComponent = (props) => <CatalogsSelectView {...props} />;
const CheckInAtGeoLocationView = (props) => <CheckInGeoTableComponent {...props} />;
const ReadArticleComponentView = (props) => <ReadArticleComponent {...props} />;
const WatchVideoComponentView = (props) => <WatchVideoComponent {...props} />;
const AwardPointsComponentView = (props) => <AwardPointsComponent {...props} />;

export const customComponents = {
  "day-parting": DayPartingView,
  "match-brands-keywords": MatchBrandsKeywordsView,
  "match-outlets-keywords": MatchOutletsKeywordsView,
  "match-products-keywords": MatchProductsKeywordsView,
  "match-products-with-payload": MatchProductsKeywordsView,
  "user-in-segment": UserInSegmentView,
  "user-segment-for-gift-processing": UserInSegmentView,
  "inclusion-segment": UserInSegmentView,
  "exclusion-segment": UserInSegmentView,
  "receipt-in-date-range": ReceiptInDateRangeView,
  "code-group-ids": CodeGroupIdsView,
  "latam-unique-code-rule": CodeGroupIdsView,
  "select-code-group": CodeGroupIdsView,
  "scan-a-code": PromotionalProductContentView,
  "scan-a-code-snack": PromotionalProductContentView,
  "scan-a-code-beverage": PromotionalProductContentView,
  "match-ids": TakeASurveyContentView,
  "package-fresh-by-date": PackageDateView,
  "fraud-receipt-conditional-approval": FraudRuleViewComponent,
  "fraud-package-conditional-approval": FraudRuleViewComponent,
  "allocate-campaign-current-points": CatalogsSelectViewComponent,
  "allocate-current-points": EmptyDataComponent,
  "allocate-bonus-points": EmptyDataComponent,
  "award-points": AwardPointsComponentView,
  "points-based-streaks": EmptyDataComponent,
  "award-points-to-referring-user": EmptyDataComponent,
  "direct-redemption-rewards": CatalogsSelectViewComponent,
  "check-in-at-geolocation": CheckInAtGeoLocationView,
  "read-article": ReadArticleComponentView,
  "watch-video": WatchVideoComponentView,
  "instant-win-outcome": WinningScheduleComponent,
  "allocate-sweepstakes-entries": SweepstakesOutcomeComponent,
  "purchase-entry": SweepstakesOutcomeComponent,
  "attach-segment": UserInSegmentView,
  "detach-segment": UserInSegmentView,
  "reward-allocation-outcome": CatalogsSelectViewComponent,
};
